// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CouponCouponGetEnrollmentDetailsDefaultResponse,
    CouponDocumentsSubmitDocumentsResponse,
    CouponDocumentsType,
    CouponEnrollmentCommunicationTypeUpdateResponse,
    CouponEnrollmentEnrollmentWithInsuranceResponse,
    CouponEnrollmentPatientMedicalBenefitResponse,
    CouponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest,
    CouponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest,
    CouponMemberCouponMemberReplaceCardReplaceCardRequest,
    CouponMemberMemberNumberStatusResponse,
    CouponMemberMemberNumberStatusWithProgramResponse,
    CouponMemberMoveMemberNumberBySurveyQuestionResponse,
    CouponMemberReplaceCardResponse,
    CouponPatientMedicalBenefitLookUpResponse,
    CouponPatientPatientSearchResponse,
    CouponRedemptionFullRedemptionListResponse,
    CouponRedemptionListResponse,
    ExtEnrollmentCommTypeUpdateRequestModel,
    ExtEnrollmentInsVerRequestModel,
    ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel,
    ExtEnrollmentPatientLookupRequestModel,
    ExtEnrollmentReenrollmentEligibilityRequestModel,
    ExtEnrollmentRequestModel,
    ExtEnrollmentUpdateRequestModel,
    GatewayError,
    GetEnrollmentDetailsRequestModel,
    MedicalBenefitRequest,
    PatientSearchRequestModel,
    RedemptionListRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeCouponApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param getEnrollmentDetailsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async couponGetEnrollmentDetails (getEnrollmentDetailsRequestModel: GetEnrollmentDetailsRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponCouponGetEnrollmentDetailsDefaultResponse>> {
        const _url_ = '/edge/coupon/GetEnrollmentDetails';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getEnrollmentDetailsRequestModel' is not null or undefined
        if (getEnrollmentDetailsRequestModel === null || getEnrollmentDetailsRequestModel === undefined) {
            throw new Error('Required parameter getEnrollmentDetailsRequestModel was null or undefined when calling couponGetEnrollmentDetails.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getEnrollmentDetailsRequestModel, "GetEnrollmentDetailsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponCouponGetEnrollmentDetailsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponCouponGetEnrollmentDetailsDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param couponDocumentsType default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentsSubmitDocuments (couponDocumentsType: CouponDocumentsType, xProgramId?: string): Promise<AxiosResponse<CouponDocumentsSubmitDocumentsResponse>> {
        const _url_ = '/edge/coupon/Documents/submitDocuments';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'couponDocumentsType' is not null or undefined
        if (couponDocumentsType === null || couponDocumentsType === undefined) {
            throw new Error('Required parameter couponDocumentsType was null or undefined when calling documentsSubmitDocuments.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponDocumentsType, "CouponDocumentsType"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponDocumentsSubmitDocumentsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponDocumentsSubmitDocumentsResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentBasicEnrollment (programId: number, extEnrollmentRequestModel: ExtEnrollmentRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentEnrollmentWithInsuranceResponse>> {
        const _url_ = '/edge/coupon/Enrollment/basicEnrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentBasicEnrollment.');
        }

        // verify required parameter 'extEnrollmentRequestModel' is not null or undefined
        if (extEnrollmentRequestModel === null || extEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentRequestModel was null or undefined when calling enrollmentBasicEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentRequestModel, "ExtEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentEnrollmentWithInsuranceResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentEnrollmentWithInsuranceResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentCommTypeUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentCommunicationTypeUpdate (programId: number, extEnrollmentCommTypeUpdateRequestModel: ExtEnrollmentCommTypeUpdateRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentCommunicationTypeUpdateResponse>> {
        const _url_ = '/edge/coupon/Enrollment/communicationTypeUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }

        // verify required parameter 'extEnrollmentCommTypeUpdateRequestModel' is not null or undefined
        if (extEnrollmentCommTypeUpdateRequestModel === null || extEnrollmentCommTypeUpdateRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentCommTypeUpdateRequestModel was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentCommTypeUpdateRequestModel, "ExtEnrollmentCommTypeUpdateRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentCommunicationTypeUpdateResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentCommunicationTypeUpdateResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentDemographicsUpdate (programId: number, extEnrollmentUpdateRequestModel: ExtEnrollmentUpdateRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentEnrollmentWithInsuranceResponse>> {
        const _url_ = '/edge/coupon/Enrollment/demographicsUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentDemographicsUpdate.');
        }

        // verify required parameter 'extEnrollmentUpdateRequestModel' is not null or undefined
        if (extEnrollmentUpdateRequestModel === null || extEnrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentUpdateRequestModel was null or undefined when calling enrollmentDemographicsUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentUpdateRequestModel, "ExtEnrollmentUpdateRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentEnrollmentWithInsuranceResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentEnrollmentWithInsuranceResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentInsVerRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentEnrollmentWithInsurance (programId: number, extEnrollmentInsVerRequestModel: ExtEnrollmentInsVerRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentEnrollmentWithInsuranceResponse>> {
        const _url_ = '/edge/coupon/Enrollment/enrollmentWithInsurance/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }

        // verify required parameter 'extEnrollmentInsVerRequestModel' is not null or undefined
        if (extEnrollmentInsVerRequestModel === null || extEnrollmentInsVerRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentInsVerRequestModel was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentInsVerRequestModel, "ExtEnrollmentInsVerRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentEnrollmentWithInsuranceResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentEnrollmentWithInsuranceResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentPatientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentHybridPatientLookup (programId: number, extEnrollmentPatientLookupRequestModel: ExtEnrollmentPatientLookupRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentPatientMedicalBenefitResponse>> {
        const _url_ = '/edge/coupon/Enrollment/hybridPatientLookup/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentHybridPatientLookup.');
        }

        // verify required parameter 'extEnrollmentPatientLookupRequestModel' is not null or undefined
        if (extEnrollmentPatientLookupRequestModel === null || extEnrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentPatientLookupRequestModel was null or undefined when calling enrollmentHybridPatientLookup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentPatientLookupRequestModel, "ExtEnrollmentPatientLookupRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentPatientMedicalBenefitResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentPatientMedicalBenefitResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentPatientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentPatientMedicalBenefit (programId: number, extEnrollmentPatientLookupRequestModel: ExtEnrollmentPatientLookupRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentPatientMedicalBenefitResponse>> {
        const _url_ = '/edge/coupon/Enrollment/patientMedicalBenefit/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }

        // verify required parameter 'extEnrollmentPatientLookupRequestModel' is not null or undefined
        if (extEnrollmentPatientLookupRequestModel === null || extEnrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentPatientLookupRequestModel was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentPatientLookupRequestModel, "ExtEnrollmentPatientLookupRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentPatientMedicalBenefitResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentPatientMedicalBenefitResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentReenrollmentEligibilityRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentReenrollmentEligibility (programId: number, extEnrollmentReenrollmentEligibilityRequestModel: ExtEnrollmentReenrollmentEligibilityRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponEnrollmentCommunicationTypeUpdateResponse>> {
        const _url_ = '/edge/coupon/Enrollment/reenrollmentEligibility/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentReenrollmentEligibility.');
        }

        // verify required parameter 'extEnrollmentReenrollmentEligibilityRequestModel' is not null or undefined
        if (extEnrollmentReenrollmentEligibilityRequestModel === null || extEnrollmentReenrollmentEligibilityRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentReenrollmentEligibilityRequestModel was null or undefined when calling enrollmentReenrollmentEligibility.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentReenrollmentEligibilityRequestModel, "ExtEnrollmentReenrollmentEligibilityRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponEnrollmentCommunicationTypeUpdateResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentCommunicationTypeUpdateResponse");
        }
        return response;
    }
    /**
     * 
     * @param couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async memberMemberNumberStatus (couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest: CouponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest, xProgramId?: string): Promise<AxiosResponse<CouponMemberMemberNumberStatusResponse>> {
        const _url_ = '/edge/coupon/Member/MemberNumberStatus';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest' is not null or undefined
        if (couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest === null || couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest === undefined) {
            throw new Error('Required parameter couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest was null or undefined when calling memberMemberNumberStatus.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest, "CouponMemberCouponMemberMemberNumberStatusMemberNumberStatusRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponMemberMemberNumberStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async memberMemberNumberStatusWithProgram (couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest: CouponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, xProgramId?: string): Promise<AxiosResponse<CouponMemberMemberNumberStatusWithProgramResponse>> {
        const _url_ = '/edge/coupon/Member/MemberNumberStatusWithProgram';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest' is not null or undefined
        if (couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === null || couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === undefined) {
            throw new Error('Required parameter couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest was null or undefined when calling memberMemberNumberStatusWithProgram.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, "CouponMemberCouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponMemberMemberNumberStatusWithProgramResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusWithProgramResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async memberMoveMemberNumberBySurveyQuestion (programId: number, extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel: ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponMemberMoveMemberNumberBySurveyQuestionResponse>> {
        const _url_ = '/edge/coupon/Member/MoveMemberNumberBySurveyQuestion/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }

        // verify required parameter 'extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel' is not null or undefined
        if (extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel === null || extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel, "ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponMemberMoveMemberNumberBySurveyQuestionResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMoveMemberNumberBySurveyQuestionResponse");
        }
        return response;
    }
    /**
     * 
     * @param couponMemberCouponMemberReplaceCardReplaceCardRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async memberReplaceCard (couponMemberCouponMemberReplaceCardReplaceCardRequest: CouponMemberCouponMemberReplaceCardReplaceCardRequest, xProgramId?: string): Promise<AxiosResponse<CouponMemberReplaceCardResponse>> {
        const _url_ = '/edge/coupon/Member/ReplaceCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'couponMemberCouponMemberReplaceCardReplaceCardRequest' is not null or undefined
        if (couponMemberCouponMemberReplaceCardReplaceCardRequest === null || couponMemberCouponMemberReplaceCardReplaceCardRequest === undefined) {
            throw new Error('Required parameter couponMemberCouponMemberReplaceCardReplaceCardRequest was null or undefined when calling memberReplaceCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(couponMemberCouponMemberReplaceCardReplaceCardRequest, "CouponMemberCouponMemberReplaceCardReplaceCardRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponMemberReplaceCardResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberReplaceCardResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param medicalBenefitRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientMedicalBenefitLookUp (programId: number, medicalBenefitRequest: MedicalBenefitRequest, xProgramId?: string): Promise<AxiosResponse<CouponPatientMedicalBenefitLookUpResponse>> {
        const _url_ = '/edge/coupon/Patient/medicalBenefitLookUp/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling patientMedicalBenefitLookUp.');
        }

        // verify required parameter 'medicalBenefitRequest' is not null or undefined
        if (medicalBenefitRequest === null || medicalBenefitRequest === undefined) {
            throw new Error('Required parameter medicalBenefitRequest was null or undefined when calling patientMedicalBenefitLookUp.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalBenefitRequest, "MedicalBenefitRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponPatientMedicalBenefitLookUpResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientMedicalBenefitLookUpResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientPatientSearch (patientSearchRequestModel: PatientSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponPatientPatientSearchResponse>> {
        const _url_ = '/edge/coupon/Patient/patientSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientSearchRequestModel' is not null or undefined
        if (patientSearchRequestModel === null || patientSearchRequestModel === undefined) {
            throw new Error('Required parameter patientSearchRequestModel was null or undefined when calling patientPatientSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSearchRequestModel, "PatientSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponPatientPatientSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientPatientSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param redemptionListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async redemptionFullRedemptionList (redemptionListRequestModel: RedemptionListRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponRedemptionFullRedemptionListResponse>> {
        const _url_ = '/edge/coupon/Redemption/fullRedemptionList';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'redemptionListRequestModel' is not null or undefined
        if (redemptionListRequestModel === null || redemptionListRequestModel === undefined) {
            throw new Error('Required parameter redemptionListRequestModel was null or undefined when calling redemptionFullRedemptionList.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(redemptionListRequestModel, "RedemptionListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponRedemptionFullRedemptionListResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionFullRedemptionListResponse");
        }
        return response;
    }
    /**
     * 
     * @param redemptionListRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async redemptionList (redemptionListRequestModel: RedemptionListRequestModel, xProgramId?: string): Promise<AxiosResponse<CouponRedemptionListResponse>> {
        const _url_ = '/edge/coupon/Redemption/List';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'redemptionListRequestModel' is not null or undefined
        if (redemptionListRequestModel === null || redemptionListRequestModel === undefined) {
            throw new Error('Required parameter redemptionListRequestModel was null or undefined when calling redemptionList.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(redemptionListRequestModel, "RedemptionListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CouponRedemptionListResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionListResponse");
        }
        return response;
    }
}
